<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="7" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="12" nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="errorTpl">
		<input
			nz-input
			[type]="type()"
			[formControlName]="controlName()"
			[placeholder]="placeholder()"
			[min]="min()"
			[max]="max()"
		/>

		<ng-template #errorTpl let-control>
			@if (control.errors?.['required']) {
				This field is required
			}
			@if (control.errors?.['minlength']) {
				Must be at least {{ control.errors?.['minlength'].requiredLength }} characters
			}
			@if (control.errors?.['email']) {
				Please enter a valid email
			}
		</ng-template>
	</nz-form-control>
</nz-form-item>
